"use client"

import { ReactNode } from "react"

type Props = {
  children: ReactNode
  className?: string
}

export default function TitleL({
  children,
  className = "",
}: Props) {
  return (
    <h1
      className={`
        relative
        text-[1.25rem]
        font-bold
        leading-8
        italic
        tracking-[-0.04rem]
        text-[var(--primary-color)]
        mb-2
        ${className}
      `}
    >
      {children}
    </h1>
  )
}